import _ from 'lodash';
import {useContext, useEffect, useRef, useState} from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import IfmsDate from '../../../ui/Date';

import {ApplicableTableSettings, codesExchangeRateList} from '../../../tableSettings';

import useFastStorage, { useTypedFastStorage } from '../../../hooks/useFastStorage';
import useFunction from '../../../hooks/useFunction';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';

import ApplicationContext from '../../../ApplicationContext';
import Float from '../../../ui/Float';
import useSystemSettings from '../../../hooks/useSystemSettings';
import {now, nowDate} from '../../../dateUtils';
import { findSecurityTask, isEveryPropertyEmpty } from '../../../util';
import { JobNames } from '../../../framework.core/JobNames';
import { CodeCurrencyListItem } from '../../../fms.data/models/CodeCurrencyListItem';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../filtering';
import { CodeExchangeRateListItem } from '../../../fms.data/models/CodeExchangeRateListItem';
import { ApiResult, InsertResult } from '../../../framework.core/data/ApiResult';
import { SQLType } from '../../../framework.core/data/SQLInfo';
import { Portal } from 'react-portal';
import { FmsSecTask } from '../../../fms.core/constants';
import EditableTable, { CellData, EditableTableHandle, TableCellAligns, TableCellTypes, TableDateType } from '../../../ui/tables/editing/EditableTable';
import GreenButton from '../../../ui/GreenButton';
import { checkTabIsDirty } from '../ReferenceFiles';
import useFilterBar from '../../../hooks/useFilterBar';
import { ListOrderBy } from "../../common/AbstractListView";
import CurrencyDropDown from '../../../uiControls/CurrencyDropDown';

import BlackInverseButton from '../../../ui/BlackInverseButton';
import constants from '../../../constants';
import IFmsReferenceFilesContext from '../IfmsReferenceFilesContext';
import CloseButton from '../../../ui/CloseButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';

// function ActionRenderer({ data, row }:any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }


// class EditableCodeExchangeRateListItem extends CodeExchangeRateListItem {
//   isNew: boolean = false;
//   isDelete: boolean = false;
// }

function EditableDateRenderer({data, row, cell}:any) {
  // useEffect(() => {
  //   const focusElement = document.getElementById('ifms-exrate-date') as HTMLInputElement;
  //   if (focusElement) {
  //     focusElement.focus();
  //     focusElement.select();
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );

  const changeLineItem = data[0].changeLineItem;
  return (
    <div style={{marginTop: '0px'}}>
      <IfmsDate dateId="ifms-exrate-date" noRangeCheck value={data[row.index].exchageDate} 
      onChange={date => {
        changeLineItem(row.index, {exchageDate: date, isUpdate: true});
        }} />
    </div>
  );
}

function CurRenderer({data, row, cell}:any) {
    
  const changeLineItem = data[0].changeLineItem;
  //const currencies = data[row.index].currencies as Array<string>;
  return (
    <div style={{marginTop: '0px'}}>
      <CurrencyDropDown value={data[row.index].currency ?? ''} onChange={primaryCurrency => {changeLineItem(row.index, {currency: primaryCurrency, isUpdate: true});}} />
      {/* <Select
        value={data[row.index].currency ?? ''}
        onChange={e => {
          changeLineItem(row.index, {currency: e.target.value, isUpdate: true});
        }}
        items={currencies.map(x => ({
          label: x,
          value: x,
        }))}

      /> */}
      {/* <TextBoxUncontrolled id="ifms-cur" maxLength={3} initialValue={inlineElement.cur} onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
        inlineElement.cur = e.target.value;
        data[row.index].setHasChanges(true);
        }} /> */}
    </div>
  );
}

function RateRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <Float floatId='exchange-rate' decimals={4} max={99999999.9999} value={data[row.index].rate} onChange={rate => {
          changeLineItem(row.index, {rate: rate, isUpdate: true});
        }}
      />
      </div>
    );
}

function formatElement(data:any) {
  return data;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function ExchangeRateComponent({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
   ifmsReferenceFilesCancel: cancelOperation,
   //ifmsReferenceFilesCancel: () => {}
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const systemSettings = useSystemSettings();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const tableRef = useRef<EditableTableHandle>(null);
  const masterTableRef = useRef<EditableTableHandle>(null);

  const [loading, setLoading] = useState(false);
  const [currencies, setCurrencies] = useState<Array<string>>([]);
  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);

  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-exchange-rate-list`, []);
  //const addingToTheFirstLine = useRef(false);
  const savedDataRef = useRef<Array<CodeExchangeRateListItem>>([]);
  const oriData = useRef<CodeExchangeRateListItem[]>([]);

  const listSec = findSecurityTask(appContext,  FmsSecTask.CodeExchangeRate);

  const tableHeight = 520;
  const listItemType = 'CodeExchangeRateListItem';

  const [focusFirstCell, setFocusFirstCell] = useState(true);
  //const { selectTableRow } = useTableNavigation('exchange-rate-list', undefined, undefined, [], false, true, true);
  const { FilterButton, search } = useFilterBar(
    codesExchangeRateList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex)
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'currency',
      orderByAscending: true,
    };
  }

  function setData(d: any, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeExchangeRateListItem, oriData.current, d));
  }

  async function fetchData(api: any, search: Search) {
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.ExchangeRate,
      listItemType,
      CodeExchangeRateListItem.calculateSearchParameters(search, CodeExchangeRateListItem.MapSearchFields),
      1, search.pageSize);

    oriData.current = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    savedDataRef.current = apiResult && apiResult.entities ? apiResult.entities : [];

    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  async function loadCurrencies(api:any) {
    const apiResult= await api.getListItems(JobNames.Currency, 
      'CodeCurrencyListItem',
      CodeCurrencyListItem.calculateSearchParameters({ pageSize: 0} as Search, CodeCurrencyListItem.MapSearchFields), 1, 0);    
    if (apiResult && apiResult.success && apiResult.entities) {
      setCurrencies(['', ...apiResult.entities.map((x:any) => x.code)]);
    }
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);

    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }

    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      //selectTableRow(0);
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await loadCurrencies(appContext.api);
    await fetchData(appContext.api, searchValue);
  }

  function getIndexOfFirstInvalidCell(rowIndex: number):number|undefined {
    if(!data){
      return undefined;
    }
    if(!data[rowIndex].exchageDate){
      showGlobalOkDialog(<p>The Data is invalid</p>);  
      return 1;
    }
    if(!data[rowIndex].currency){
      showGlobalOkDialog(<p>Select Currency</p>);
      return 2;
    }
    if(data[rowIndex].rate !== null){
      if((data[rowIndex].rate ?? 0) <= 0 ){
        showGlobalOkDialog(<p>The Rate must be greater than zero</p>);
        return 3;
      }
    }
    return undefined;
  }

  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    const currentDate = now();
    const newItem = new CodeExchangeRateListItem();
    newItem.createBy = systemSettings?.userId ?? '';
    newItem.createDate = currentDate;
    newItem.currency = currencies[0];
    newItem.id = 0;
    newItem.updateBy = systemSettings?.userId ?? '';
    newItem.updateDate = currentDate;
    newItem.exchageDate = nowDate();
    newItem.rate = 0;
    newItem.isNew = true;

    setHasChanges(true);

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newItem
    };
  }

  function applyToLineItem(rowIndex: number, change: Partial<CodeExchangeRateListItem>|null) {
    if (!change || !data) {
      return;
    }
    const newData = [...data];
    const checkData = data[rowIndex];
    if (!change.isNew && (change.exchageDate !== checkData.exchageDate || change.currency !== checkData.currency ||
      change.rate !== checkData.rate)) {
      _.merge(newData[rowIndex], { ..._.omit(change, ['id']), hasBeenChanged: true });
      setData(newData);
      setHasChanges(true);
    }
  }

  function deleteEntity(index: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[index];
    if (element.id > 0) {
      let deleteRow = savedDataRef.current.find(x => x.id === element.id);
      if (deleteRow) {
        deleteRow.isDelete = true;
        setHasChanges(true);
      }
    }
    data.splice(index, 1);
    setData(data);

    return true;
  }

  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  async function save() {
    if(!data) return;

    let errMsg = '';
    const dataToSave = data.filter((x:any) => x.id <= 0 || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) return;

    setLoading(true);

    for(let i = 0; i < dataToDelete.length; ++i){
      const s = dataToDelete[i];
      const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if(!apiResult || !apiResult.success)
      errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }

    if(dataToSave.length > 0){
      const apiResult = await appContext.api.saveList(listItemType, dataToSave);

      if(!apiResult || !apiResult.success){
        errMsg += (errMsg ? '\n' : '' ) + apiResult?.message;
      }

      if(apiResult?.result) {
        apiResult?.result.forEach((item: any) => {
          const index = data.findIndex((d: any) => d.id === item.oldId);
          if(index >= 0){
            data[index].id = item.newId;
            data[index].hasBeenChanged = false;
          }
          // 정상 저장된 경우 isNew Flag 제거
          if(item.isNew) {
            delete data[index].isNew;
          }
        });
      }
    }

    if(errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }

    setData(data);
    savedDataRef.current = _.cloneDeep(data);
    oriData.current = _.cloneDeep(data);

    setLoading(false);
    setHasChanges(false);
    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  const additionalEmptyValuesAndProperties = {
    'exchageDate': nowDate(),
    'currency': currencies[0]
  };

  const OtherCompareProperties = [
    'exchageDate',
    'currency',
    'rate',
  ];

  const tableOptions: ApplicableTableSettings = {
    customTableId: 'codes-exchange-rate-list',
    ref: tableRef,
    selectable: true,
    tableName: 'codesExchangeRateList',
    ...codesExchangeRateList,
    height: `${tableHeight}px`,
    //data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, currencies, requestOperationCancel, listSec })),
    data: (data ?? []).map((x: any, i: number) => ({ ...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem, currencies })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'exchageDate', EditCell: EditableDateRenderer },
      { accessor: 'currency',  EditCell: CurRenderer },
      { accessor: 'rate',  EditCell: RateRenderer },
      { accessor: 'createDate' },
      { accessor: 'createBy' },
      { accessor: 'updateDate' },
      { accessor: 'updateBy' },
      //{ accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'exchageDate')
        return { type: TableCellTypes.Date, dateType:TableDateType.Date, value: rowData.exchageDate };
      else if (accessor === 'currency')
        return { type: TableCellTypes.Text, value: rowData.currency ?? '' ,  align: TableCellAligns.Center };
      else if (accessor === 'rate')
        return { type: TableCellTypes.Number, decimal:4, value: rowData.rate};
      else if (accessor === 'createDate')
        return { type: TableCellTypes.Date, dateType:TableDateType.Date, value: rowData.createDate};
      else if (accessor === 'createBy')
        return { type: TableCellTypes.Text, value: rowData.createBy};
      else if (accessor === 'updateDate')
        return { type: TableCellTypes.Date, dateType:TableDateType.Date, value: rowData.updateDate};
      else if (accessor === 'updateBy')
        return { type: TableCellTypes.Text, value: rowData.updateBy};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
     else if (accessor === 'createDate'||accessor === 'createBy'||accessor === 'updateDate'||accessor === 'updateBy')
        return true;
      else
        return false;
    },

    useEditControls: (listSec && (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel)) ?? true,
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = (listSec && listSec?.grantAdd) ?? true;

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Exchange Rate</h1>
      </Portal> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='list-screen-refresh' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={reload} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      {/* <div className="reference-codes-title-row"> */}
      {/*<div className="oi-doc-title-sub-row">

           <d iv style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click Exchange Rate to Edit
          </div> 
        /div> */}

      {/* <div style={{width: '320px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => {setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})}} />
        </div> */}
      <div style={{ display: 'flex', width: '625px' }}>
        <div style={{ marginLeft: 'auto' }}></div>

        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {/* <SecondaryButton name='codes-exchange-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; */}
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(false); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      {/* </div> */}
      {/* <SmartTable {...tableOptions} /> */}
      <div style={{ width: '625px' }}>
        <EditableTable
          initializeFocusedCell={focusFirstCell}
          ref={masterTableRef}
          tableOptions={tableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
          getIndexOfFirstInvalidCell={getIndexOfFirstInvalidCell}
          shouldConfirmBeforeDelete={(rowIndex:number) => {
            return !isEveryPropertyEmpty(_.pick(data[rowIndex], OtherCompareProperties), additionalEmptyValuesAndProperties)
          }}
        />
      </div>
    </div>
  );
}

export default ExchangeRateComponent;
